import { Suspense } from "react";
import { Catcher } from "../base/Catcher.js";

export const LOADING_ELEMENT = (
	<aside>
		<div className="card pad-none height-3x effect-waiting" />
	</aside>
);

/**
 * Load a component.
 * - Wrapped in `<Catcher>` so child components can throw errors.
 * - Wrapped in `<Suspense>` so child components can throw promises.
 */
export function Loader({ children }: { children: React.ReactNode }): React.ReactElement {
	return (
		<Catcher>
			<Suspense fallback={LOADING_ELEMENT}>{children}</Suspense>
		</Catcher>
	);
}
